import ContactComponent from "../components/Contact";
import PageHeader from "../components/PageHeader";

const Contact = () => {
  return (
    <>
      <PageHeader title="Contact" />
      <ContactComponent />
    </>
  );
};

export default Contact;
